import { AnnualReportStep } from '@modeso/types__aumico-lib-annualreport-be';

export const DEFAULT_AR_NAVIGATION: AnnualReportStep[] = [
    AnnualReportStep.GENERAL_INFORMATION,
    AnnualReportStep.IMPORT_BALANCE_INCOME,
    AnnualReportStep.CFS,
    AnnualReportStep.NOTES,
    AnnualReportStep.AOP,
    AnnualReportStep.EMS,
    AnnualReportStep.ADJUSTMENTS_RECLASSIFICATION,
    AnnualReportStep.CR,
    AnnualReportStep.PRINT,
];

export const INITIAL_AR_NAVIGATION: AnnualReportStep[] = [
    AnnualReportStep.GENERAL_INFORMATION,
    AnnualReportStep.IMPORT_BALANCE_INCOME,
    AnnualReportStep.BALANCE_ACCOUNT_PROOF,
    AnnualReportStep.INCOME_ACCOUNT_PROOF,
    AnnualReportStep.PRINT,
];
